module.exports = __webpack_public_path__ + "img/ergoregion-2.0a69eaf8.png";